import * as React from 'react';

export default function Unauthenticated() {
    return (
        <div>YOU NEED TO BE LOGGED IN TO GO THERE</div>
    );
}

